<button
  mat-icon-button
  [matMenuTriggerFor]="accountMenu"
  class="profile-button account-menu-button"
  [attr.aria-label]="ariaLabel"
  [matTooltip]="tooltip"
  matTooltipPosition="below"
  type="button"
  data-testid="project-selector-account-menu-trigger"
>
  @if (user$ | async; as user) {
    <img
      [src]="user.photoURL || 'assets/default-avatar.svg'"
      [alt]="user.displayName || user.email || 'User'"
      referrerpolicy="no-referrer"
      class="profile-picture account-avatar"
    />
  } @else {
    <img src="assets/default-avatar.svg" alt="User" class="profile-picture account-avatar" />
  }
</button>

<mat-menu #accountMenu="matMenu" class="user-menu account-menu-panel" [overlapTrigger]="false">
  @if (user$ | async; as user) {
    <div class="user-info">
      <div class="user-name">{{ user.displayName || 'User' }}</div>
      <div class="user-email">
        <span class="logged-in-label">{{ userRoleLabel }}</span>
        <br />
        {{ user.email || 'No email' }}
      </div>
    </div>
  } @else {
    <div class="user-info">
      <div class="user-name">Not signed in</div>
      <div class="user-email">
        <span class="logged-in-label">{{ userRoleLabel }}</span>
      </div>
    </div>
  }
  <mat-divider></mat-divider>

  <!-- Slotted items from parent (if any) -->
  <ng-content select="[slot=user-menu]"></ng-content>

  <!-- Switch Account -->
  @if (showSwitchAccount) {
    <button mat-menu-item (click)="onSwitchAccount()" class="switch-account-menu-item">
      <mat-icon>swap_horiz</mat-icon>
      <span>Switch Account</span>
    </button>
  }

  <!-- Billing & Account -->
  @if (showBilling) {
    <button
      data-testid="project-selector-account-menu-billing"
      mat-menu-item
      (click)="onNavigateToBilling()"
      class="billing-menu-item"
    >
      <mat-icon>account_balance_wallet</mat-icon>
      <span>Billing & Account</span>
    </button>
  }

  <!-- Admin Console -->
  @if (hasAdminRole$ | async) {
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="onNavigateToAdmin()" class="admin-menu-item">
      <mat-icon>admin_panel_settings</mat-icon>
      <span>Admin Console</span>
    </button>
  }

  <mat-divider></mat-divider>

  <!-- Sign Out -->
  <button mat-menu-item (click)="onSignOut()" class="sign-out-menu-item">
    <mat-icon>logout</mat-icon>
    <span>Sign Out</span>
  </button>

  <!-- Legal links footer -->
  @if (showLegalLinks) {
    <mat-divider></mat-divider>
    <div class="menu-legal-links">
      <a routerLink="/privacy" (click)="onLegalLinkClick()" aria-label="Privacy Policy">Privacy</a>
      <span class="separator">•</span>
      <a routerLink="/terms" (click)="onLegalLinkClick()" aria-label="Terms of Service">Terms</a>
    </div>
  }
</mat-menu>
